import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { ContactsIcon } from 'foundations-assets';
import { getFeatureTableTooltipKey } from './utils';
import { jsx as _jsx } from "react/jsx-runtime";
const FeatureTableUserIcon = ({
  freeUserAccess,
  productLine,
  showTooltip = true,
  canViewNewSeats = false
}) => {
  const tooltipKey = getFeatureTableTooltipKey(canViewNewSeats, freeUserAccess, productLine);
  return /*#__PURE__*/_jsx(Tooltip, {
    disabled: !showTooltip,
    placement: "top",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: tooltipKey
    }),
    children: /*#__PURE__*/_jsx(ContactsIcon, {
      "data-test-id": "user-icon"
    })
  });
};
export default FeatureTableUserIcon;